import logoReze from '../../Images/logo-reze.jpg';
import logoFFR13 from '../../Images/logo-ffr13.jpg';
import logoComite44 from '../../Images/logo-comite-44.png';
import logoJoovia from '../../Images/logo-joovia.png';
import logoDeker from '../../Images/logo-deker-transparent.png';
import logoAtol from '../../Images/logo-atol-original.jpeg';
import { Helmet } from 'react-helmet-async';
import './Partners.css';
import Logo from '../../Components/Logo/Logo';

const institutionalPartners = [
  {
    logo: logoFFR13,
    name: 'FFR13',
    link: 'https://www.ffr13.fr/',
  },
  {
    logo: logoReze,
    name: 'ville de Rezé',
    link: 'https://www.reze.fr/',
  },
  {
    logo: logoComite44,
    name: 'Comité 44',
    link: 'https://www.facebook.com/p/Comite-Loire-Atlantique-rugby-%C3%A0-XIII-100070366539852/',
  },
];

const financialPartners = [
  {
    logo: logoJoovia,
    name: 'Joovia',
    link: 'http://www.joovia.fr/',
  },
  {
    logo: logoDeker,
    name: 'Deker',
    link: 'https://deker.fr/',
  },
  {
    logo: logoAtol,
    name: 'Atol',
    link: 'https://magasins.atol.fr/france/cible-reze-193',
  },
];

const PartnersPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <html lang="fr" />
        <title>Rezé XIII - Partenaires</title>
        <meta
          name="description"
          content="Page présentant les partenaires du club de rugby à XIII de Rezé"
        />
        <meta
          name="keywords"
          content="Rugby, Rugby à XIII, Club de Rugby, Rezé, Partenaires, Sponsors"
        />
        <link
          rel="canonical"
          href="https://reze-rugby13.netlify.app/partenaires"
        />
      </Helmet>
      <section
        className="partners-container"
        aria-labelledby="partners-page-title"
      >
        <Logo />
        <h1 id="partners-page-title" className="partners-title">
          Nos Partenaires
        </h1>
        <section aria-labelledby="partners-thanks">
          <p className="partners-text">
            Nous remercions nos partenaires pour leur soutien qui contribue au
            développement et au fonctionnement de notre club.
          </p>
          <p className="partners-text">
            C'est grâce à eux que nous pouvons pérenniser nos activités!
          </p>
        </section>
        <section aria-labelledby="institutional-partners-title">
          <h2 id="institutional-partners-title" className="partners-subtitle1">
            Institutionnels
          </h2>
          <div className="partners-grid">
            {institutionalPartners.map(partner => (
              <a
                href={partner.link}
                key={partner.name}
                target="_blank"
                rel="noopener noreferrer"
                title={`En savoir plus sur ${partner.name} - s'ouvre dans un nouvel onglet`}
                className="partner-link"
              >
                <img
                  src={partner.logo}
                  alt={`Logo de ${partner.name}`}
                  className="partner-logo"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </section>
        <section aria-labelledby="financial-partners-title">
          <h2 id="financial-partners-title" className="partners-subtitle1">
            Financiers
          </h2>
          <div className="partners-grid">
            {financialPartners.map(partner => (
              <a
                href={partner.link}
                key={partner.name}
                target="_blank"
                rel="noopener noreferrer"
                title={`En savoir plus sur ${partner.name} - s'ouvre dans un nouvel onglet`}
                className="partner-link"
              >
                <img
                  src={partner.logo}
                  alt={`Logo de ${partner.name}`}
                  className="partner-logo"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </section>
      </section>
    </>
  );
};

export default PartnersPage;
